import { isValidNum } from "verdi-common/utils/mathUtils";

export function parseOrganizationCoordinateField(input: string): number | null {
    const parsed = parseFloat(input.trim());
    return isValidNum(parsed) ? parsed : null;
}
